import {randomId,View,map,interpolate} from "vritra";
import css from "./InterpolatedView.module.css";


export default function InterpolatedView(props){
    const {parent,id=randomId("interpolatedview")}=props;
    const interpolatedview=View({parent,id,className:css.interpolatedview});

    interpolatedview.innateHTML=`
        <div class="${css.scroll}">
            ${map(10,(i)=>`<div>${(i+1)*10} %</div>`)}
        </div>
        <div class="${css.background}"></div>
    `;

    const backgroundEl=interpolatedview.querySelector(`.${css.background}`);
    const scrollEl=interpolatedview.querySelector(`.${css.scroll}`);
    scrollEl.onscroll=()=>{
        requestAnimationFrame(()=>{
            const value=interpolate(scrollEl.scrollLeft,[0,scrollEl.scrollWidth-scrollEl.clientWidth],[0,100]);
            backgroundEl.style.width=`${value}%`;
        });
    }

    return interpolatedview;
}
